(function () {
  var settings = window.iwSettings || {};

  /* Mobile menu */
  function initMenu() {
    var toggle = document.querySelector('[data-iw-menu-toggle]');
    var nav = document.getElementById('iw-nav');
    if (!toggle || !nav) return;
    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    }
    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  /* Tabs (companies vs individuals) */
  function initTabs(root) {
    root.querySelectorAll('[data-iw-tabs]').forEach(function (tabs) {
      var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));
      function select(btn) {
        buttons.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      buttons.forEach(function (btn, i) {
        btn.addEventListener('click', function () { select(btn); });
        btn.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!dir) return;
          var next = buttons[(i + dir + buttons.length) % buttons.length];
          select(next);
          next.focus();
        });
      });
    });
  }

  /* Booking card -> WhatsApp (or booking link) */
  function initBooker(root) {
    root.querySelectorAll('[data-iw-booker]').forEach(function (form) {
      var where = form.querySelector('[data-iw-where]');
      var cars = form.querySelector('[data-iw-cars]');
      var hint = form.querySelector('[data-iw-hint]');

      function tooFewForHome() {
        return where && cars && where.value.indexOf('Home') === 0 && ['1', '2'].indexOf(cars.value) !== -1;
      }
      function update() { if (hint) hint.hidden = !tooFewForHome(); }
      if (where) where.addEventListener('change', update);
      if (cars) cars.addEventListener('change', update);

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (tooFewForHome()) {
          update();
          cars.focus();
          return;
        }
        var data = new FormData(form);
        if (form.dataset.productUrl) {
          var target = new URL(form.dataset.productUrl, window.location.href);
          target.searchParams.set('variant', data.get('variant'));
          target.searchParams.set('qty', data.get('cars'));
          target.searchParams.set('where', data.get('where'));
          window.location.href = target.toString();
          return;
        }
        if (settings.bookingUrl) {
          var url = new URL(settings.bookingUrl, window.location.href);
          data.forEach(function (v, k) { if (v) url.searchParams.set(k, v); });
          window.location.href = url.toString();
          return;
        }
        var lines = [
          "Hi iWashCars, I'd like to book a wash.",
          '• Booking for: ' + data.get('who'),
          '• Location type: ' + data.get('where'),
          data.get('area') ? '• Area: ' + data.get('area') : null,
          '• Cars: ' + data.get('cars')
        ].filter(Boolean);
        var wa = 'https://wa.me/' + (settings.whatsapp || '') + '?text=' + encodeURIComponent(lines.join('\n'));
        window.open(wa, '_blank', 'noopener');
      });
    });
  }

  /* Booking product page: car picker, cars stepper, prefill from the homepage card */
  function initProduct(root) {
    root.querySelectorAll('[data-iw-pdp]').forEach(function (pdp) {
      var idInput = pdp.querySelector('[data-iw-variant-input]');
      var price = pdp.querySelector('[data-iw-price]');
      var media = pdp.querySelector('[data-iw-pdp-image] img');
      var qty = pdp.querySelector('[data-iw-qty]');
      var where = pdp.querySelector('[data-iw-where]');
      var buy = pdp.querySelector('button[name="add"]');

      pdp.querySelectorAll('input[type="radio"][data-price]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked || !idInput) return;
          idInput.value = radio.value;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          if (price) price.textContent = radio.dataset.price;
          if (media && radio.dataset.image) { media.removeAttribute('srcset'); media.src = radio.dataset.image; }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', radio.value);
          window.history.replaceState({}, '', url.toString());
        });
      });

      pdp.querySelectorAll('[data-iw-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qty) return;
          qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(btn.dataset.iwStep, 10));
          qty.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      function checkHome() {
        if (!where || !qty || !buy) return;
        var tooFew = where.value.indexOf('Home') === 0 && (parseInt(qty.value, 10) || 1) < 3;
        buy.toggleAttribute('data-needs-3', tooFew);
        pdp.classList.toggle('iw-pdp--home-warning', tooFew);
      }
      if (where) where.addEventListener('change', checkHome);
      if (qty) qty.addEventListener('change', checkHome);

      var params = new URLSearchParams(window.location.search);
      var wanted = params.get('qty') || params.get('cars');
      if (qty && wanted) qty.value = Math.max(1, parseInt(wanted, 10) || 1);
      if (where && params.get('where')) {
        Array.prototype.forEach.call(where.options, function (o) { if (o.value === params.get('where')) where.value = o.value; });
      }
      checkHome();
    });
  }

  /* Phone booking bar: hides while a real booking button is on screen; on the booking page it presses that button */
  function initStickyBar() {
    var bar = document.querySelector('[data-iw-sticky]');
    if (!bar) return;
    var targets = Array.prototype.slice.call(document.querySelectorAll('[data-iw-sticky-hide]'));
    var visible = new Set();
    /* On the booking page the bar is there from the start: the real Book & pay button
       sits below the fold, so waiting for a scroll leaves the page with no way to book. */
    var fromTheStart = bar.dataset.iwSticky === 'product';
    function update() {
      var down = Math.max(window.scrollY || 0, document.body.scrollTop || 0, document.documentElement.scrollTop || 0);
      var show = visible.size === 0 && (fromTheStart || down > 120);
      bar.hidden = !show;
      document.body.classList.toggle('iw-has-sticky', show);
    }
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target); });
        update();
      });
      targets.forEach(function (t) { io.observe(t); });
    }
    window.addEventListener('scroll', update, { passive: true });
    document.addEventListener('scroll', update, { passive: true, capture: true });
    window.addEventListener('resize', update, { passive: true });
    update();
    /* Cowlendar hides our own buy button and puts its own in its place, so once
       that has happened we watch its button instead: the bar steps aside when
       the real one is on screen, and covers the page the rest of the time. */
    function adopt() {
      document.querySelectorAll('.cowlendar-btn').forEach(function (b) {
        if (b.dataset.iwWatched || bar.contains(b)) return;
        b.dataset.iwWatched = '1';
        if (io) io.observe(b);
      });
      update();
    }
    setTimeout(adopt, 1200);
    setTimeout(adopt, 3000);
    setTimeout(adopt, 6000);

    var buy = bar.querySelector('[data-iw-sticky-buy]');
    if (buy) {
      buy.addEventListener('click', function () {
        var real = document.querySelector('.iw-pdp__buy .cowlendar-btn:not(.cowlendar-hidden)') ||
                   document.querySelector('.iw-pdp__buy button[name="add"]:not(.cowlendar-hidden)');
        if (real) { real.scrollIntoView({ block: 'center' }); real.click(); }
      });
      document.addEventListener('change', function (e) {
        var r = e.target;
        if (!r.matches || !r.matches('.iw-pdp input[type="radio"][data-price]') || !r.checked) return;
        var price = bar.querySelector('[data-iw-sticky-price]');
        var title = bar.querySelector('[data-iw-sticky-title]');
        if (price) price.textContent = r.dataset.price;
        var name = r.closest('label') && r.closest('label').querySelector('.iw-pill__name');
        if (title && name) title.textContent = name.textContent;
      });
    }
  }

  /* Side-swipe rows on a phone: dots under the row so people know there is more
     to the right, and tapping a dot moves to that card. */
  function initSwipe(root) {
    root.querySelectorAll('[data-iw-swipe]').forEach(function (row) {
      if (row.dataset.iwSwipeReady) return;
      row.dataset.iwSwipeReady = '1';
      var cards = Array.prototype.slice.call(row.children);
      if (cards.length < 2) return;

      var dots = document.createElement('ul');
      dots.className = 'iw-dots';
      cards.forEach(function (card, i) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Show ' + (i + 1) + ' of ' + cards.length);
        b.addEventListener('click', function () {
          row.scrollTo({ left: card.offsetLeft - row.offsetLeft, behavior: 'smooth' });
        });
        li.appendChild(b);
        dots.appendChild(li);
      });
      row.parentNode.insertBefore(dots, row.nextSibling);

      var buttons = Array.prototype.slice.call(dots.querySelectorAll('button'));

      /* Measure the cards once and remember where they are. Reading their
         positions on every frame of a swipe forces the browser to redo its
         layout mid-gesture, which is what made the scroll stutter. */
      var centres = [];
      var current = -1;
      function measure() {
        centres = cards.map(function (card) { return card.offsetLeft + card.offsetWidth / 2; });
      }
      function mark() {
        if (!centres.length) return;
        var middle = row.scrollLeft + row.offsetLeft + row.clientWidth / 2;
        var nearest = 0, best = Infinity;
        for (var i = 0; i < centres.length; i++) {
          var d = Math.abs(centres[i] - middle);
          if (d < best) { best = d; nearest = i; }
        }
        if (nearest === current) return;
        current = nearest;
        buttons.forEach(function (b, i) { b.setAttribute('aria-current', i === nearest ? 'true' : 'false'); });
      }
      var ticking = false;
      row.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; mark(); });
      }, { passive: true });

      window.addEventListener('resize', function () { measure(); current = -1; mark(); }, { passive: true });
      /* pictures arriving late change the card widths, so measure again then */
      row.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', function () { measure(); mark(); }, { once: true });
      });
      measure();
      mark();
    });
  }

  /* Cart +/− and Remove, without reloading the page. The number changes on the
     spot; quick clicks on one row are gathered into a single save, and that one
     request brings back the freshly rendered cart so only the rows, prices and
     subtotal are swapped (the note box is left alone). Cowlendar disables the
     number box on booked washes, so lines are changed by key rather than through
     that box. Without JavaScript the links still work on their own. */
  function initCart(root) {
    root.querySelectorAll('form[data-iw-cart-section]').forEach(function (form) {
      if (form.dataset.iwCartReady) return;
      form.dataset.iwCartReady = '1';
      var sectionId = form.dataset.iwCartSection;
      var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var timers = {};
      var wanted = {};
      var inFlight = 0;
      var queue = Promise.resolve();

      function settled() { return inFlight === 0 && Object.keys(timers).length === 0; }

      function updateCount(count) {
        document.querySelectorAll('.iw-header__count').forEach(function (el) {
          if (count > 0) el.textContent = count; else el.remove();
        });
        document.querySelectorAll('.iw-header__icon[href$="/cart"]').forEach(function (a) {
          a.setAttribute('aria-label', 'Cart, ' + count + ' items');
        });
      }

      function render(html) {
        var fresh = html && new DOMParser().parseFromString(html, 'text/html');
        var section = form.closest('.iw-section');
        var freshItems = fresh && fresh.querySelector('[data-iw-cart-items]');
        if (!freshItems) {
          var freshSection = fresh && fresh.querySelector('.iw-section');
          if (freshSection && section) section.replaceWith(freshSection); else window.location.reload();
          return;
        }
        form.querySelector('[data-iw-cart-items]').replaceWith(freshItems);
        var subtotal = fresh.querySelector('[data-iw-cart-subtotal]');
        if (subtotal) form.querySelector('[data-iw-cart-subtotal]').innerHTML = subtotal.innerHTML;
        form.classList.remove('is-updating');
      }

      function send(key) {
        delete timers[key];
        var qty = wanted[key];
        inFlight++;
        queue = queue.then(function () {
          return fetch(cartRoot + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty, sections: [sectionId], sections_url: window.location.pathname })
          }).then(function (r) {
            if (!r.ok) throw new Error(r.status);
            return r.json();
          }).then(function (cart) {
            inFlight--;
            updateCount(cart.item_count);
            /* only redraw once every click has been saved, so a newer number on screen isn't undone */
            if (settled()) render(cart.sections && cart.sections[sectionId]);
          });
        }).catch(function () { window.location.reload(); });
      }

      function setQty(row, qty) {
        var key = row.dataset.iwCartKey;
        var input = row.querySelector('input[type="number"]');
        qty = Math.max(0, qty);
        if (input) input.value = qty;
        row.classList.toggle('is-removing', qty === 0);
        wanted[key] = qty;
        form.classList.add('is-updating');
        clearTimeout(timers[key]);
        timers[key] = setTimeout(function () { send(key); }, qty === 0 ? 0 : 350);
      }

      form.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-iw-cart-step], [data-iw-cart-remove]');
        var row = btn && btn.closest('[data-iw-cart-key]');
        if (!row) return;
        e.preventDefault();
        var input = row.querySelector('input[type="number"]');
        var current = input ? parseInt(input.value, 10) || 0 : 0;
        setQty(row, btn.hasAttribute('data-iw-cart-remove') ? 0 : current + parseInt(btn.dataset.iwCartStep, 10));
      });

      form.addEventListener('change', function (e) {
        var row = e.target.matches('input[type="number"]') && e.target.closest('[data-iw-cart-key]');
        if (row) setQty(row, parseInt(e.target.value, 10) || 0);
      });

      /* Checkout or Update pressed mid-save: finish the saves first, then carry on */
      form.addEventListener('submit', function (e) {
        if (settled()) return;
        e.preventDefault();
        var submitter = e.submitter;
        Object.keys(timers).forEach(function (key) { clearTimeout(timers[key]); send(key); });
        queue.then(function () {
          if (submitter) submitter.click(); else form.submit();
        });
      });
    });
  }

  /* Logo strip: pause the slide while a finger is on it */
  function initMarquee(root) {
    root.querySelectorAll('[data-iw-marquee]').forEach(function (m) {
      if (m.dataset.iwMarqueeReady) return;
      m.dataset.iwMarqueeReady = '1';
      m.addEventListener('touchstart', function () { m.setAttribute('data-iw-paused', ''); }, { passive: true });
      m.addEventListener('touchend', function () { m.removeAttribute('data-iw-paused'); }, { passive: true });
    });
  }

  function init(root) {
    initTabs(root || document);
    initBooker(root || document);
    initProduct(root || document);
    initSwipe(root || document);
    initMarquee(root || document);
    initCart(root || document);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    init(document);
    initStickyBar();
  });

  /* Re-run when sections are edited in the theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest && e.target.closest('[role="tabpanel"]');
    if (!panel) return;
    var btn = document.querySelector('[aria-controls="' + panel.id + '"]');
    if (btn) btn.click();
  });
})();
